var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.isButton
    ? _c(
        "button",
        {
          staticClass: "file-chooser-item",
          class: {
            selected: _vm.isSelected,
            disabled: !_vm.isFolderChooser,
          },
          attrs: {
            title: _vm.folderName,
          },
          on: {
            click: _vm.selectFolder,
            dblclick: _vm.openFolder,
          },
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: _vm.folderIcon,
              size: 48,
            },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.folderName))]),
        ],
        1
      )
    : _c(
        "tr",
        {
          class: {
            selected: _vm.isSelected,
          },
        },
        [
          _c(
            "td",
            {
              staticClass: "document-icon",
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "#",
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.selectFolder.apply(null, arguments)
                    },
                    dblclick: function dblclick($event) {
                      $event.preventDefault()
                      return _vm.openFolder.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: _vm.folderIcon,
                      size: 24,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("td", [
            _c(
              "a",
              {
                attrs: {
                  href: "#",
                },
                on: {
                  click: function click($event) {
                    $event.preventDefault()
                    return _vm.selectFolder.apply(null, arguments)
                  },
                  dblclick: function dblclick($event) {
                    $event.preventDefault()
                    return _vm.openFolder.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.folderName))]
            ),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [!_vm.folderIsEmpty ? [_vm._v(_vm._s(_vm.folderSize))] : _vm._e()],
            2
          ),
          _vm._v(" "),
          _c(
            "td",
            {
              staticClass: "responsive-hidden",
            },
            [_vm._v(_vm._s(_vm.folderOwner))]
          ),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.folderMkdate))]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }